// extracted by mini-css-extract-plugin
export default {"loader":"style_loader__14R95","rotate":"style_rotate__6Quu-","gray":"style_gray__Yu80r","prixClipFix":"style_prixClipFix__wfqyN"};